module.exports = __webpack_public_path__ + "assets/img/medicalCarebg3.586ceb8d.png";